<script>
    import { mapState } from 'vuex';

    export default {
        name: 'footer-component',
        computed: {
            ...mapState([
                'isLoggedIn',
                'loggedUser',
                'isDarkMode'
            ]),
        },
        methods: {
        }
    };
</script>